import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useState, useMemo, useContext } from "react";
import { ActionIcon } from "../ActionIcon/index.js";
import { Icons24 } from "../Icons24Sprite/index.js";
import { SideNavigationContext } from "./helpers.js";
import { SideNavigationItem } from "./NavigationItem/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index33.css';const container = "_container_arzzv_1";
const collapsed = "_collapsed_arzzv_12";
const logoContainer = "_logoContainer_arzzv_15";
const header = "_header_arzzv_20";
const headerTitle = "_headerTitle_arzzv_28";
const body = "_body_arzzv_42";
const footer = "_footer_arzzv_49";
const fill = "_fill_arzzv_59";
const s = {
  container,
  collapsed,
  logoContainer,
  header,
  headerTitle,
  body,
  footer,
  fill
};
const SideNavigationRoot = withThemeAndSize(
  forwardRef(({ children, className, storageKey, initialIsExpanded = false, onStateChanged, ...rest }, ref) => {
    const [isExpanded, setIsExpanded] = useState(() => {
      if (!storageKey) {
        return initialIsExpanded;
      }
      if (localStorage.getItem(storageKey) === "true") {
        return true;
      }
      return initialIsExpanded;
    });
    const contextValue = useMemo(
      () => ({
        isExpanded,
        toggleIsExpanded: () => {
          const newValue = !isExpanded;
          setIsExpanded(newValue);
          onStateChanged == null ? void 0 : onStateChanged(newValue);
          if (storageKey) {
            localStorage.setItem(storageKey, newValue ? "true" : "false");
          }
        }
      }),
      [isExpanded, storageKey]
    );
    return /* @__PURE__ */ jsx(SideNavigationContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx("aside", { ref, className: clsx(s.container, { [s.collapsed]: !isExpanded }, className), ...rest, children }) });
  })
);
const SideNavigationHeader = withThemeAndSize(
  forwardRef(({ children, logo, ...rest }, ref) => {
    const { toggleIsExpanded, isExpanded } = useContext(SideNavigationContext);
    return /* @__PURE__ */ jsxs("div", { ref, ...rest, className: s.header, children: [
      /* @__PURE__ */ jsxs("div", { className: s.headerTitle, children: [
        /* @__PURE__ */ jsx("div", { className: s.logoContainer, children: logo }),
        /* @__PURE__ */ jsx(
          ActionIcon,
          {
            icon: /* @__PURE__ */ jsx(Icons24, { name: isExpanded ? "MenuFoldFill" : "MenuUnfoldFill" }),
            onClick: toggleIsExpanded,
            actionIconType: "ghost"
          }
        )
      ] }),
      children
    ] });
  })
);
const SideNavigationBody = withThemeAndSize(
  forwardRef(({ children, fill: fill2, ...rest }, ref) => {
    return /* @__PURE__ */ jsx("div", { ref, ...rest, className: clsx(s.body, { [s.fill]: fill2 }), children });
  })
);
const SideNavigationFooter = withThemeAndSize(
  forwardRef(({ children, ...rest }, ref) => {
    return /* @__PURE__ */ jsx("div", { ref, ...rest, className: s.footer, children });
  })
);
const SideNavigation = {
  Root: SideNavigationRoot,
  Header: SideNavigationHeader,
  Item: SideNavigationItem,
  Body: SideNavigationBody,
  Footer: SideNavigationFooter
};
export {
  SideNavigation
};
